import { render, staticRenderFns } from "./long-title-nofoot.vue?vue&type=template&id=18675c5c&scoped=true"
import script from "./long-title-nofoot.vue?vue&type=script&lang=js"
export * from "./long-title-nofoot.vue?vue&type=script&lang=js"
import style0 from "./long-title-nofoot.vue?vue&type=style&index=0&id=18675c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18675c5c",
  null
  
)

export default component.exports